import { Component, Input, ViewChild } from '@angular/core';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { ListViewComponent } from 'components/layout/list-view/list-view.component';
import { InputStateDirective } from 'directives/input-state.directive';
import { CredentialType } from 'enums/CredentialType';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ComponentUrl } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { AddMultipleComponent, IAddedItem } from 'components/input/add-multiple/add-multiple.component';
import { CustomCredentials } from 'constants/CustomCredentials';

@Component({
	selector: 'view-team-credentials',
	templateUrl: './view-team-credentials.component.html',
	imports: [Layout, ListView, InputStateDirective, TranslatePipe, AddMultipleComponent]
})
@ComponentUrl('view-team-credentials')

export class ViewTeamCredentialsComponent {

	@ViewChild('saveButton') submitButton!: SubmitButtonComponent;
	@ViewChild('credentialList') credentialList!: ListViewComponent; 
	_teamId:string = '';
	@Input()
	set teamId(id: string) {
		if (id) {
			this._teamId = id;
			this.loadTeamCredentials();
		}
	}
	get teamId() {
		return this._teamId;
	}

	credentialType = CredentialType;
	credentials: { credentialType: CredentialType, key: string, enabled: boolean, wasEnabled: boolean }[] = [];
	canSave = false;
	customCredentials: string[] = [];
	customCredentialItems: IAddedItem[] = [];
	sharedCustomCredentialItems: IAddedItem[] = [];

	constructor(private readonly userService: UserService) {
	}
	
	loadTeamCredentials() {
		const credentialTypes = Array.from(this.credentialType.getKeys());
		const team = this.userService.team(this._teamId)!;
		this.credentials = [];
		credentialTypes.forEach(credential => {
			let credentialEnabled = team.teamCredentials.some(cred => cred.credential == credential[0]);
			this.credentials.push({ credentialType: credential[0], key: credential[1], enabled: credentialEnabled, wasEnabled: credentialEnabled });
		});
		this.customCredentials = team.teamCustomCredentials.map(tcc => tcc.customCredential);
		this.customCredentialItems = this.customCredentials.map(cc => { return { value: cc, label: cc }; });
		this.sharedCustomCredentialItems = CustomCredentials.values.map(cc => { return { value: cc, label: cc }; });
	}

	enable(credential: { credentialType: CredentialType, key: string, enabled: boolean, wasEnabled: boolean }) {
		credential.enabled = !credential.enabled
		credential.wasEnabled = !credential.wasEnabled
	}

	save() {
		let enabledCredentials = this.credentials.filter(credential => credential.enabled).map(credential => credential.credentialType);
		this.userService.updateTeamCredentials(this.teamId, enabledCredentials, this.customCredentials).then(() => {
			this.submitButton.succeeded();
			this.credentialList.sort();
			this.canSave = false;
		});
	}

	onChange() {
		this.canSave = true;
	}

	onChangeCustomCredentials(selectedItems: IAddedItem[]) {
		const removeItems = this.customCredentials.filter(cc => selectedItems.map(i => i.value.toLowerCase()).indexOf(cc.toLowerCase()) < 0);
		const addItems = selectedItems.filter(item => this.customCredentials.map(cc => cc.toLowerCase()).indexOf(item.value.toLowerCase()) < 0);

		for (let removeItem of removeItems) {
			this.customCredentials.splice(this.customCredentials.indexOf(removeItem), 1);
		}
		for (let addItem of addItems) {
			this.customCredentials.push(addItem.value);
		}
		this.canSave = true;
	}
}
